import clsx from 'clsx'
import React, { FC } from 'react'
import ModalCore from 'react-overlays/Modal'

import { Dialog, DialogProps } from './Dialog'
import { Fade } from './Fade'
import styles from './Modal.module.scss'

export type SharedModalProps = {
  ID?: string | null
  isOpen?: boolean
  onHide?: () => void
  onSubmit?: () => void
}

export interface ModalProps extends DialogProps, SharedModalProps {
  className?: string
  easyClose?: boolean
  showBackdrop?: boolean
}

/**
 * @deprecated The Component should not be used - use the NativeModal instead
 */
export const Modal: FC<ModalProps> = ({
  className,
  easyClose = true,
  isOpen = false,
  onHide,
  showBackdrop = true,
  ...props
}) => (
  <ModalCore
    backdropTransition={Fade}
    className={className}
    onBackdropClick={() => easyClose && onHide && onHide()}
    onEscapeKeyDown={() => easyClose && onHide && onHide()}
    onHide={onHide}
    renderBackdrop={showBackdrop ? renderProps => <div className={styles.backdrop} {...renderProps} /> : undefined}
    renderDialog={
      // The modelWrapper Blocks clicking events from reaching the backdrop so it should handle
      // closing the modal itself
      renderProps => (
        <div {...renderProps} className={clsx(styles.modalWrapper, renderProps.className)} onClick={() => easyClose && onHide && onHide()}>
          <Dialog {...props} onHide={onHide} />
        </div>
      )
    }
    show={isOpen}
    transition={Fade}
  />
)
